import { motion } from "framer-motion";

const ITEMS = [
  "ERP Platform",
  "Revenue Assurance",
  "AI Analytics",
  "Industry Cloud",
  "Multi-Business",
  "Offline First",
];

const Banner = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-[#0A2540] to-[#0E2C44] py-10">
      {/* Background Glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(76,175,80,0.15),transparent_70%)]" />

      <motion.div
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative max-w-7xl mx-auto px-6"
      >
        <div className="flex flex-wrap justify-center gap-4">
          {ITEMS.map((item, index) => (
            <motion.div
              key={item}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                delay: index * 0.08,
                duration: 0.4,
              }}
              className="
                px-5
                py-3
                rounded-full
                bg-white/5
                backdrop-blur-md
                border
                border-white/10
                text-white
                font-medium
                hover:border-[#4CAF50]/40
                hover:bg-white/10
                transition-all
              "
            >
              {item}
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Banner;
